import { render, staticRenderFns } from "./PropertyContactButton.vue?vue&type=template&id=1ddc3eae&scoped=true"
import script from "./PropertyContactButton.vue?vue&type=script&lang=js"
export * from "./PropertyContactButton.vue?vue&type=script&lang=js"
import style0 from "./PropertyContactButton.vue?vue&type=style&index=0&id=1ddc3eae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddc3eae",
  null
  
)

export default component.exports